import React from 'react';
import _ from 'lodash';
import { Card, CardContent, CardHeader } from '@mui/material';
import { useQuery } from 'react-fetching-library';
import { ReceiptForm } from './ReceiptForm';
import { InvoiceForm } from './InvoiceForm';
import { CorrectiveInvoiceForm } from './CorrectiveInvoiceForm';
import { ProformaInvoice } from './ProformaInvoiceForm';
import { InvoiceForReceiptForm } from './InvoiceForReceiptForm';
import { CorrectiveReceiptForm } from './CorrectiveReceiptForm';
import { InvoiceForMarginReceiptForm } from './InvoiceForMarginReceiptForm';
import { AdvanceInvoiceForm } from './AdvanceInvoiceForm';

import { getInvoiceDataAction } from '../../../../../../../services/request';
import { MarginInvoiceForm } from './MarginInvoiceForm';
import { MarginReceiptForm } from './MarginReceiptForm';
import { DebitNoteForm } from './DebitNoteForm';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%'
};

export const DocumentBase = props => {
  const { closeDialog, type, order, season, module, editData, submitCallback, manual } = props;
  const { loading, payload, error } = useQuery(getInvoiceDataAction(order.id, type.code));
  const [invoiceBaseData, setInvoiceBaseData] = React.useState({});

  React.useEffect(() => {
    if (!loading && !error && _.isEmpty(editData)) {
      setInvoiceBaseData(payload);
    } else if (!loading && !error) {
      if (_.isEmpty(editData)) {
        setInvoiceBaseData({ invoices: payload.invoices, receipts: payload.receipts });
      } else {
        setInvoiceBaseData({ invoices: payload.invoices, receipts: !_.isNil(payload.receipts) ? [...payload.receipts, ...editData.assigned_receipts] : [] });
      }
    }
  }, [loading]);

  return (
    <Card sx={{ ...style }}>
      <CardHeader title={type.name} />
      <CardContent >
        {type.name === 'Paragon'
          ? <ReceiptForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} manual={manual} />
          : type.name === 'Faktura'
            ? <InvoiceForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} manual={manual} />
            : type.name === 'Faktura korygująca'
              ? <CorrectiveInvoiceForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} manual={manual} />
              : type.name === 'Faktura proforma'
                ? <ProformaInvoice order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} manual={manual} />
                : type.name === 'Faktura do paragonu'
                  ? <InvoiceForReceiptForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} manual={manual} />
                  : type.name === 'Faktura do paragonu marża'
                    ? <InvoiceForMarginReceiptForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} manual={manual} />
                    : type.name === 'Paragon korygujący'
                      ? <CorrectiveReceiptForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} manual={manual} />
                      : type.name === 'Faktura marża'
                        ? <MarginInvoiceForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} manual={manual} />
                        : type.name === 'Paragon marża'
                          ? <MarginReceiptForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} manual={manual} />
                          : type.name === 'Faktura zaliczkowa'
                            ? <AdvanceInvoiceForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} manual={manual} />
                            : type.name === 'Nota obciążeniowa'
                              ? <DebitNoteForm order={order} invoiceBaseData={invoiceBaseData} handleClose={closeDialog} module={module} season={season} editData={editData} submitCallback={submitCallback} manual={manual} />
                              : null}
      </CardContent>
    </Card>
  );
};
